import styled from 'styled-components';

export const BenefitGroupTileActions = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: none;
`;

export const BenefitGroupTileContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 296px;
  height: 150px;
  margin-bottom: 8px;
  padding: 16px 16px 16px 16px;
  background-color: ${props => props.theme.gray0};
  outline: 1px solid ${props => props.theme.altGray2};
  cursor: ${props => (props.noHover ? 'cursor' : 'pointer')};

  &:hover {
    outline: ${props =>
      props.noHover ? `1px solid ${props.theme.altGray2}` : 'none'};
    box-shadow: ${props =>
      props.noHover ? 'none' : '0px 0px 20px rgba(0, 0, 0, 0.13)'};

    ${BenefitGroupTileActions} {
      display: block;
    }
  }
`;

export const BenefitGroupTileHeading = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  width: 100%;
  position: relative;
`;

export const BenefitGroupTileTitle = styled.div`
  font-size: ${props => props.theme.sizeMedium};
  font-weight: ${props => props.theme.fontSemiBold};
  color: ${props => props.theme.gray85};
  word-break: break-word;
`;

export const BenefitGroupLimit = styled.div`
  font-size: ${props => props.theme.sizeMedium};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 56px;
  padding-right: 24px;
  border-right: solid 2px ${props => props.theme.primaryBackColorLight};
`;

export const BenefitGroupLimitValue = styled.div`
  font-weight: ${props => props.theme.fontSemiBold};
  padding-top: 16px;
`;

export const BenefitGroupTileIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    max-width: 100%;
    max-height: 100%;
  }
`;
